import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { HttpErrorHandler } from '../../shared/http-error-handler';
import { List } from '../../shared/list';

import { ControlItem } from '../../_models/control-item';
import { IncidenceService } from '../../_services/incidence.service';
import { TideService } from '../../_services/tide.service';
import { IncidenceFilter } from '../../_models/control-item';

@Component({
  selector: 'app-incidence-list',
  templateUrl: './incidence-list.component.html',
  styleUrls: ['./incidence-list.component.sass'],
})
export class IncidenceListComponent extends List implements OnInit {
  errorMessage: string;
  filter: IncidenceFilter = new IncidenceFilter();

  constructor(
    private incidenceService: IncidenceService,
    private tideService: TideService,
    private router: Router,
    private route: ActivatedRoute,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(incidenceService, new ControlItem(), router, route);
  }

  ngOnInit() {
    this.defaultFilterParams = 'status=error';
    this.initList('incidences', this.filter);
  }

  checkForUpdate(event, tide, status) {
    event.preventDefault();
    this.tideService.requestForUpdate(tide.id, status).subscribe(
      (response) => {
        this.updateTideIncidencesStatus(tide.id, response.update_requested);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  updateTideIncidencesStatus(tide_id, status) {
    for (const incidence of this.collection) {
      if (incidence.tide.id === tide_id) {
        incidence.tide.update_requested = status;
      }
    }
  }

  switchStatus(event, incidence) {
    event.preventDefault();
    this.incidenceService.switchStatus(incidence.id).subscribe(
      (response) => {
        incidence.status = response['status'];
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/incidences/incidence-list/incidence-list.component.ts